import { EQuickLookType } from '../../../../Card/components/Card/types';
import { CardChecklistsHOC } from '../../../../CardChecklists/hocs/CardChecklistsHOC/CardChecklistsHOC';
import { IApplicationState, TCardId } from '../../../../../../../../../types/types';
import * as React from 'react';
import { DriveDocs } from '../../../../driveDocs/components/DriveDocs/DriveDocs';
import {
    getDriveDocsByCardIdCreateSelector
} from '../../../../../../../../../store/model/driveDocs/selectors/getDriveDocsByCardId';
import { ERestDriveDocType } from '../../../../../../../../../types/rest/IRestDriveDoc';
import { CardSubcardsHOC } from '../../../../CardSubcards/hocs/CardSubcardsHOC/CardSubcardsHOC';
import { CardDescription } from '../../../../CardDescription/CardDescription';
import { getCard } from '../../../../../../../../../store/model/selectors/getCard';
import { CardComments } from '../../../../CardComments/CardComments';
import { getCardComments } from '../../../../../../../../../store/model/selectors/getCardComments';
import { getBoardPermissionsIsReadonly } from '../../../../../selectors/getBoardPermissionsIsReadonly';
import { getBoardIdByCardId } from '../../../../../../../../../store/model/selectors/getBoardIdByCardId';
import { TStatus } from '../../../../../../../../../types/model';
import { CARD_CLASS } from '../../../../../constants';
import {
    getAuthUserSettingsCommentsSort
} from '../../../../../../../../../store/model/authUser/selectors/getAuthUserSettingsCommentsSort';
import { ICardChecklists } from '../../../../../../../../../store/model/checklists/checklists/types';
import { ICard } from '../../../../../../../../../store/model/card/types';

const getCardAttachments = getDriveDocsByCardIdCreateSelector();

export const getQuickLookComponent = (
    state: IApplicationState,
    quickLook: EQuickLookType,
    cardId: TCardId,
    checklists: ICardChecklists,
    subcards: ICard[],
    isClone: boolean,
    onHeightChange: () => void,
    onToggleLoadingImg: (id: string) => void,
) => {
    if (quickLook === EQuickLookType.CHECKLISTS) {
        const className = CARD_CLASS + '__module';
        const boardId = getBoardIdByCardId(state, cardId);
        const { status } = getCard(state, cardId);
        const isReadonly = getBoardPermissionsIsReadonly(state, boardId) || status === TStatus.STATUS_SERVICE_TEMPLATE;
        return <CardChecklistsHOC
            className={`${className} ${className}--checklists`}
            cardId={cardId}
            isQuickLook
            isReadonly={isReadonly}
            checklists={checklists}
            onHeightChange={onHeightChange}
            onToggleLoadingImg={onToggleLoadingImg}
        />;
    } else if (quickLook === EQuickLookType.DESCRIPTION) {
        const { description } = getCard(state, cardId);
        return <CardDescription
            description={description}
            isQuickLook
            onHeightChange={onHeightChange}
            onToggleLoadingImg={onToggleLoadingImg}
        />;
    } else if (quickLook === EQuickLookType.ATTACHMENTS) {
        const pinnedAttachments = getCardAttachments(state, cardId, ERestDriveDocType.CARD, true, false).map(driveDoc => driveDoc.id);
        const attachments = getCardAttachments(state, cardId, ERestDriveDocType.CARD, undefined, true)
            .filter(({ id }) => !pinnedAttachments.includes(id));
        return <DriveDocs mainDriveDocSet={attachments} cardId={cardId} isClone={isClone} />;
    } else if (quickLook === EQuickLookType.SUBCARDS) {
        const className = CARD_CLASS + '__module';
        return <CardSubcardsHOC
            className={`${className} ${className}--subcards`}
            isClone={isClone}
            cardId={cardId}
            subcards={subcards}
            onHeightChange={onHeightChange}
            onToggleLoadingImg={onToggleLoadingImg}
        />;
    } else if (quickLook === EQuickLookType.COMMENTS) {
        const comments = getCardComments(state, cardId);
        const order = getAuthUserSettingsCommentsSort(state);
        const driveDocs = getCardAttachments(state, cardId, ERestDriveDocType.COMMENT, undefined, true);
        return <CardComments
            comments={comments}
            order={order}
            driveDocs={driveDocs}
            onHeightChange={onHeightChange}
            onToggleLoadingImg={onToggleLoadingImg}
        />;
    }
}
